webpackJsonp([101471198812329],{

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\tpadding: 10px 25px;\n"], ["\n\tpadding: 10px 25px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(17);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _lodash = __webpack_require__(73);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledFlexComponent = __webpack_require__(23);
	
	var _styledFlexComponent2 = _interopRequireDefault(_styledFlexComponent);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Typography = __webpack_require__(18);
	
	var _evergreenUi = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogRoll = function (_Component) {
		_inherits(BlogRoll, _Component);
	
		function BlogRoll() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, BlogRoll);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				years: []
			}, _this.addToYears = function (year) {
				_this.setState(function (prevState) {
					return {
						years: [].concat(prevState.years, [year])
					};
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		BlogRoll.prototype.render = function render() {
			var posts = this.props.data.allMarkdownRemark.edges;
	
			return _react2.default.createElement(
				RollContainer,
				null,
				_react2.default.createElement(_reactHelmet2.default, { title: "Blog" }),
				_react2.default.createElement(
					_Typography.CenteredFull,
					null,
					_react2.default.createElement(
						_Typography.Title,
						null,
						"Narrow Road Home Blog"
					)
				),
				_react2.default.createElement(
					BlogGrid,
					null,
					posts.map(function (post) {
						var year = post.node.frontmatter.date.match(/(\d{4})/g).pop();
						return _react2.default.createElement(
							_react.Fragment,
							null,
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: post.node.fields.slug },
								_react2.default.createElement(
									_evergreenUi.Card,
									{ border: "extraMuted", key: post.node.id, hoverElevation: 4 },
									_react2.default.createElement(
										_styledFlexComponent2.default,
										null,
										_react2.default.createElement(BlogImage, { resolutions: post.node.frontmatter.featured_image.childImageSharp.resolutions }),
										_react2.default.createElement(
											BlogFlex,
											{ column: true },
											_react2.default.createElement(
												_evergreenUi.Strong,
												{ size: 700 },
												_lodash2.default.truncate(post.node.frontmatter.title, { length: 60, separator: " " })
											),
											_react2.default.createElement(
												BlogTags,
												null,
												post.node.frontmatter.tags && post.node.frontmatter.tags.map(function (tag) {
													return _react2.default.createElement(
														_gatsbyLink2.default,
														{ to: "/tags/" + _lodash2.default.kebabCase(tag) },
														_react2.default.createElement(
															_evergreenUi.Pill,
															{ style: { display: "inline-block" } },
															tag
														)
													);
												})
											),
											_react2.default.createElement(
												_evergreenUi.Strong,
												{ size: 200, color: _evergreenUi.colors.green },
												post.node.frontmatter.date
											),
											_react2.default.createElement(
												_evergreenUi.Text,
												null,
												post.node.excerpt
											)
										)
									)
								)
							)
						);
					})
				)
			);
		};
	
		return BlogRoll;
	}(_react.Component);
	
	exports.default = BlogRoll;
	
	
	var RollContainer = _styledComponents2.default.div.withConfig({
		displayName: "blog-roll__RollContainer"
	})(["margin:0 auto;margin-top:", "vw;max-width:1400px;@media screen and (max-width:1400px){padding:0 ", "vw;}"], 100 / 24, 100 / 24);
	
	var BlogTags = _styledComponents2.default.div.withConfig({
		displayName: "blog-roll__BlogTags"
	})(["display:flex;grid-gap:5px;grid-template-columns:repeat(auto-fill,1fr);margin:0.5rem 0;strong:not(:first-child){margin-left:5px;}"]);
	
	var BlogGrid = _styledComponents2.default.div.withConfig({
		displayName: "blog-roll__BlogGrid"
	})(["display:grid;grid-template-columns:repeat(auto-fit,500px);grid-gap:35px 50px;justify-content:center;margin-bottom:5rem;@media screen and (max-width:500px){grid-template-columns:repeat(auto-fit,calc(100vw / 24 * 22));grid-gap:25px 0;}"]);
	
	var BlogFlex = _styledFlexComponent2.default.extend(_templateObject);
	
	var BlogImage = (0, _styledComponents2.default)(_gatsbyImage2.default).withConfig({
		displayName: "blog-roll__BlogImage"
	})(["margin-right:15px;border-radius:10px;@media screen and (max-width:600px){width:80px !important;height:80px !important;border-radius:5px;}"]);
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-roll-jsx-6dd188f2eb25d37802a4.js